import { render, staticRenderFns } from "./Forget.vue?vue&type=template&id=d6223142&scoped=true&"
import script from "./Forget.vue?vue&type=script&lang=js&"
export * from "./Forget.vue?vue&type=script&lang=js&"
import style0 from "./Forget.vue?vue&type=style&index=0&id=d6223142&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6223142",
  null
  
)

export default component.exports